
<mat-tab-group #tabGroup>
  <mat-tab label="Current">
    <rsValidForm #form="rsValidForm" [rsValidOnceInteracted]="true">
      <div class="inputs">

        <div class="field">
          <div class="label">Project Area</div>
          <div class="input">
            <mat-form-field [floatLabel]="'always'" appearance="fill">
              <mat-label>Area</mat-label>
              <input matInput [(ngModel)]="input.areaOfUse" placeholder="Area" type="number" rsValid="greaterZero" />
              <strong matSuffix>ha</strong>
            </mat-form-field>
          </div>
        </div>

        <div class="field">
          <div class="label">Estimated percentage bare</div>
          <div class="input">
            <mat-form-field [floatLabel]="'always'" appearance="fill">
              <mat-label>% Bare</mat-label>
              <input matInput [ngModel]="(input.prePercentageBare * 100) | number:'1.0-2'" (ngModelChange)="input.prePercentageBare = $event / 100" placeholder="Nitrogen use" type="number"
                     rsValid="percentGreaterZero"
                     rsValidHint="Estimated percentage of land that is bare per year (%)" />
              <strong matSuffix>%</strong>
            </mat-form-field>
          </div>
        </div>

        <div class="field">
          <div class="label">Estimated level of sediment movement</div>
          <div class="input">
            <div class="w-100">
              <mat-form-field [floatLabel]="'always'" appearance="fill" class="calculated">
                <mat-label>Sediment movement</mat-label>
                <input matInput [value]="input.preSedimentMovement | number:'1.0-2'" readonly placeholder="Sediment movement" />
                <strong matSuffix>ton/ha</strong>
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'" appearance="fill" class="calculated">
                <mat-label>Nitrogen movement</mat-label>
                <input matInput [value]="input.preNitrogenMovement | number:'1.0-2'" readonly placeholder="Nitrogen movement" />
                <strong matSuffix>kg/ha</strong>
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'" appearance="fill" class="calculated">
                <mat-label>Phosphorus movement</mat-label>
                <input matInput [value]="input.prePhosphorusMovement | number:'1.0-2'" readonly placeholder="Phosphorus movement" />
                <strong matSuffix>kg/ha</strong>
              </mat-form-field>
            </div>
          </div>
        </div>

      </div>
    </rsValidForm>
  </mat-tab>
  <mat-tab label="New">
    <rsValidForm #form="rsValidForm" [rsValidOnceInteracted]="true">
      <div class="inputs">

        <div class="field">
          <div class="label">New percentage bare</div>
          <div class="input">
            <mat-form-field [floatLabel]="'always'" appearance="fill">
              <mat-label>% Bare</mat-label>
              <input matInput [ngModel]="(input.postPercentageBare * 100) | number:'1.0-2'" (ngModelChange)="input.postPercentageBare = $event / 100" placeholder="Nitrogen use" type="number" rsValid="percentZero"
                     rsValidHint="New estimated percentage of land that is bare per year (%)" />
              <strong matSuffix>%</strong>
            </mat-form-field>
          </div>
        </div>

        <div class="field">
          <div class="label">New level of sediment movement</div>
          <div class="input">
            <div class="w-100">
              <mat-form-field [floatLabel]="'always'" appearance="fill" class="calculated">
                <mat-label>Sediment movement</mat-label>
                <input matInput [value]="input.preSedimentMovement | number:'1.0-2'" readonly placeholder="Sediment movement" />
                <strong matSuffix>ton/ha</strong>
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'" appearance="fill" class="calculated">
                <mat-label>Nitrogen movement</mat-label>
                <input matInput [value]="input.preNitrogenMovement | number:'1.0-2'" readonly placeholder="Nitrogen movement" />
                <strong matSuffix>kg/ha</strong>
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'" appearance="fill" class="calculated">
                <mat-label>Phosphorus movement</mat-label>
                <input matInput [value]="input.prePhosphorusMovement | number:'1.0-2'" readonly placeholder="Phosphorus movement" />
                <strong matSuffix>kg/ha</strong>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="field">
          <div class="label">Improved level of sediment movement</div>
          <div class="input">
            <div class="w-100">
              <mat-form-field [floatLabel]="'always'" appearance="fill" class="calculated">
                <mat-label>Sediment movement</mat-label>
                <input matInput [value]="input.changeSedimentMovement | number:'1.0-2'" readonly placeholder="Sediment movement" />
                <strong matSuffix>ton/ha</strong>
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'" appearance="fill" class="calculated">
                <mat-label>Nitrogen movement</mat-label>
                <input matInput [value]="input.changeNitrogenMovement | number:'1.0-2'" readonly placeholder="Nitrogen movement" />
                <strong matSuffix>kg/ha</strong>
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'" appearance="fill" class="calculated">
                <mat-label>Phosphorus movement</mat-label>
                <input matInput [value]="input.changePhosphorusMovement | number:'1.0-2'" readonly placeholder="Phosphorus movement" />
                <strong matSuffix>kg/ha</strong>
              </mat-form-field>
            </div>
          </div>
        </div>

      </div>
    </rsValidForm>
  </mat-tab>
  <mat-tab label="Outcome">
    <rsValidForm #form="rsValidForm" [rsValidOnceInteracted]="true">
      <div class="inputs">

        <div class="field">
          <div class="label">Likelihood of practice achieving results</div>
          <div class="input">
            <mat-form-field [floatLabel]="'always'" appearance="fill">
              <mat-label>Likelihood</mat-label>
              <input matInput [(ngModel)]="input.likelihood" type="number" placeholder="Likelihood" rsValid="pc_likelihood"
                     rsValidHint="0.5 Poor, 0.75 Good, 1 Excellent"
                     step="0.05"

              />
            </mat-form-field>
          </div>
        </div>

        <div class="field">
          <div class="label">Assess the number of years that actions will continue for</div>
          <div class="input">
            <mat-form-field [floatLabel]="'always'" appearance="fill"
                            rsValidHint="Value = 1 for annual actions, to a maximum of 5 for more permanent actions">
              <mat-label>Number of years</mat-label>
              <mat-select [(ngModel)]="input.years">
                <mat-option [value]="1">1 - Annual actions</mat-option>
                <mat-option [value]="2">2</mat-option>
                <mat-option [value]="3">3</mat-option>
                <mat-option [value]="4">4</mat-option>
                <mat-option [value]="5">5 - More permanent</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="field">
          <div class="label">Adjusted improvement level of sediment movement</div>
          <div class="input">
            <div class="w-100">
              <mat-form-field [floatLabel]="'always'" appearance="fill" class="calculated">
                <mat-label>Sediment movement</mat-label>
                <input matInput [value]="input.adjustmentSedimentMovement | number:'1.0-2'" readonly placeholder="Sediment movement" />
                <strong matSuffix>ton/ha</strong>
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'" appearance="fill" class="calculated">
                <mat-label>Nitrogen movement</mat-label>
                <input matInput [value]="input.adjustmentNitrogenMovement | number:'1.0-2'" readonly placeholder="Nitrogen movement" />
                <strong matSuffix>kg/ha</strong>
              </mat-form-field>
              <mat-form-field [floatLabel]="'always'" appearance="fill" class="calculated">
                <mat-label>Phosphorus movement</mat-label>
                <input matInput [value]="input.adjustmentPhosphorusMovement | number:'1.0-2'" readonly placeholder="Phosphorus movement" />
                <strong matSuffix>kg/ha</strong>
              </mat-form-field>
            </div>
          </div>
        </div>

      </div>
    </rsValidForm>
  </mat-tab>
</mat-tab-group>

<br/>
<ng-template #actionButtons>

  <button mat-button (click)="this.dialogHandles.close(false)">
    Cancel
  </button>

  <button color="primary" mat-button (click)="next()" *ngIf="tabGroup.selectedIndex !== tabGroup._allTabs.length - 1">
    Next <mat-icon>chevron_right</mat-icon>
  </button>

  <button color="primary" mat-button (click)="save()" *ngIf="tabGroup.selectedIndex === tabGroup._allTabs.length - 1">
    <mat-icon>save</mat-icon> Save
  </button>

</ng-template>
